// extracted by mini-css-extract-plugin
export default {"tooltip":"p4MeOHHK_PpfTl4H_RE3","tooltipContent":"ZkPDEKfUHgoVUqj9KOSn"};